import Vue from "vue";
import { RouteConfig } from "vue-router";

import { PermissionName } from "../../common/mixins/permission";
import ShippopCreateCodPage from "./pages/ShippopCreateCodPage.vue";

export const ShippopRouter: (prefix?: string) => RouteConfig[] = (
  prefix = "shippop"
) => [
  {
    name: "ShippopCreateCodPage",
    path: `${prefix}/cod/create`,
    component: ShippopCreateCodPage,
    meta: { title: "Register COD Shippop" },
    beforeEnter: (to, from, next) => {
      if (
        Vue.prototype.$dep.authUseCase.hasPermission(
          PermissionName.SHIPPOP_COD_CREATE
        )
      ) {
        document.title = to.meta.title;
        next();
        return;
      }
      next({ path: "/" });
    }
  }
];
